const updateSearchHeading = (function() {
  const searchBox = document.getElementById('search-box');
  const searchHeading = document.getElementById('search-heading');

  if (searchBox) {
    searchBox.addEventListener('change', function() {
      searchHeading.innerText = 'Results for "' + this.value + '"';
    });
  }
})();

export default updateSearchHeading;
